import React from "react";
import { II } from "../../components/common/Icons";
import SearchBar from "../../components/common/SearchBar";
import NotificationBell from "../../components/common/NotificationBell";
import { AvatarDisplay } from "../../components/common/AvatarUpload";import "../../assets/styles/HR/HrTopbar.css";

const NAV = [
{ k: "dashboard", l: "Dashboard" }, { k: "interns", l: "Interns" }, { k: "employees", l: "Employees" },
{ k: "people", l: "People" },
{ k: "attendance", l: "Attendance" }, { k: "leave", l: "Attendance" }, { k: "payroll", l: "Payroll" },
{ k: "advances", l: "Advances" }, { k: "reports", l: "Reports" }, { k: "performance", l: "Performance" }, { k: "tickets", l: "Help Desk" },
{ k: "policies", l: "Policies" }, { k: "announcements", l: "Announcements" },
{ k: "calendar", l: "Calendar" }, { k: "chat", l: "Chat" }, { k: "notes", l: "Notes" },
{ k: "audit", l: "Audit Log" }, { k: "analytics", l: "Analytics" },
{ k: "offboarding", l: "Offboarding" }, { k: "settings", l: "Settings" }];


function HrTopbar({ a, onLogout, user, onNav }) {
  return (
    <div className="TB">
      <div className="TB-bc">
        HR Admin {II("right", 14)} <b>{NAV.find((n) => n.k === a)?.l || "Dashboard"}</b>
      </div>
      <div className="hrtopbar-inline-1">
        <SearchBar portalName="HR" resetKey={a} />
        <div onClick={() => onNav && onNav("chat")} title="Chat" className="hrtopbar-inline-2">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
        </div>
        <div className="hrtopbar-inline-3"><NotificationBell onNavigate={onNav} /></div>
        <div onClick={() => onNav && onNav("settings")} className="hrtopbar-inline-4"><AvatarDisplay src={user?.avatar} name={user?.name} size={34} /></div>
        <div className="TB-ib hrtopbar-inline-5" onClick={onLogout} title="Sign Out">
          {II("logout")}
        </div>
      </div>
    </div>);

}

export default HrTopbar;